export enum ScreenSize{
    MobileMx = 480,
    TabletMx = 768,
    LaptopXx = 1024,
    DesktopMx = 1200,

}